import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { DOWNLOAD } from '@hobs/constants/userManual';

export function getUserManual() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('UserManual/Export', { forceBlob: true })
      .then(response => {
        if (response) {
          dispatch(success());

          return { success: true, payload: response };
        } else {
          dispatch(failure());
          const data = {
            status: response.status,
            payload: response.response
              ? JSON.parse(response.response)
              : response
          };
          return { success: false, ...data };
        }
      })
      .catch(() => {
        dispatch(failure());
      });
  };

  function request() {
    return { type: DOWNLOAD.REQUEST };
  }
  function success() {
    return { type: DOWNLOAD.SUCCESS };
  }
  function failure() {
    return { type: DOWNLOAD.FAILURE };
  }
}
